






















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import { requireGet, requirePost, addStatistics, ChangeURLArg } from '../api'
@Component
export default class ShipAddress extends Vue {
  @Prop({ default: false }) show: boolean
  @Prop({ default: {} }) addressInfo: any
  @Prop() receiverId: number
  @Prop() attendReceiverId: number
  @Prop() defaultReceiverId: number
  @Prop() isConfirmed: boolean
  @Prop() isSuccess: boolean
  @Prop() myTeamId: number
  @Prop() id: any
  get btnText() {
    if (this.isConfirmed) {
      return '已确认'
    } else if (
      this.receiverId ||
      this.attendReceiverId ||
      this.defaultReceiverId
    ) {
      return '确认地址'
    } else {
      return '填写地址'
    }
  }

  get note_text() {
    if (this.isConfirmed) {
      return '*您已确认收货地址，获得奖品后将根据该地址进行发货'
    } else if (
      this.receiverId ||
      this.attendReceiverId ||
      this.defaultReceiverId
    ) {
      return '*若您获得实体奖品，为保证奖品能顺利发货，请您先确认收货地址。（未确认地址视为主动放弃奖品）'
    } else {
      return '*若您获得实体奖品，为保证奖品能顺利发货，请您先填写收货地址。（未确认地址视为主动放弃奖品）'
    }
  }

  async goAddress(type) {
    if (type === 'confirm') {
      const { data } = await requirePost(
        `/api/activity/appActivity/teamActivity/confirmAddress`,
        {
          team_id: this.myTeamId,
          receiver_id:
            this.receiverId || this.attendReceiverId || this.defaultReceiverId,
          team_activity_id: this.id,
        }
      )
      if (data.status_code === 'ERROR') return this.$Toast(data.message)
      this.isConfirmed = true
      this.$emit('update:isConfirmed', true)
      this.$Toast('地址已确认')
    } else {
      this.$emit('goToAddress')
    }
  }
  close() {
    this.$emit('update:show', false)
  }
}
